import _dateFormat from "./dateFormat";
export const dateFormat = _dateFormat;
/**
 * Throttle
 * @param fn {func}
 * @param delay {number}
 */

export const Throttle = (fn, delay = 500) => {
  const self = fn;
  const isFirst = false;
  let timer = null;

  return (...rest) => {
    if (!isFirst) {
      self(...rest);
    }

    if (timer) {
      return;
    }

    timer = setTimeout(() => {
      clearTimeout(timer);
      timer = null;
      self(...rest);
    }, delay);
  };
};

/**
 * 防抖函数
 * @param method 事件触发的操作
 * @param delay 多少毫秒内连续触发事件，不会执行
 * @returns {Function}
 */
export function debounce(func, wait = 300, immediate) {
  let timeout, args, context, timestamp, result

  const later = function() {
    // 据上一次触发时间间隔
    const last = +new Date() - timestamp

    // 上次被包装函数被调用时间间隔 last 小于设定时间间隔 wait
    if (last < wait && last > 0) {
      timeout = setTimeout(later, wait - last)
    } else {
      timeout = null
      // 如果设定为immediate===true，因为开始边界已经调用过了此处无需调用
      if (!immediate) {
        result = func.apply(context, args)
        if (!timeout) context = args = null
      }
    }
  }

  return function(...args) {
    context = this
    timestamp = +new Date()
    const callNow = immediate && !timeout
    // 如果延时不存在，重新设定延时
    if (!timeout) timeout = setTimeout(later, wait)
    if (callNow) {
      result = func.apply(context, args)
      context = args = null
    }

    return result
  }
}

export const getDateRange = () => {
  const dateRange = [];
  const startTime1 = new Date();
  const startTime3 = new Date();
  const startTime7 = new Date();
  const startTime30 = new Date();
  const endTime = new Date();
  // 今天
  dateRange.push({
    label: "今天",
    type: "1",
    addTime: startTime1.setTime(
      startTime1.getTime() -
        (startTime1.getHours() * 3600 +
          startTime1.getMinutes() * 60 +
          startTime1.getSeconds()) *
          1000
    ),
    endTime: endTime.getTime()
  });
  // 最近三天
  dateRange.push({
    label: "最近三天",
    type: "2",
    addTime: startTime3.setTime(startTime3.getTime() - 3600 * 1000 * 24 * 3),
    endTime: endTime.getTime()
  });
  // 最近一周
  dateRange.push({
    label: "最近一周",
    type: "3",
    addTime: startTime7.setTime(startTime7.getTime() - 3600 * 1000 * 24 * 7),
    endTime: endTime.getTime()
  });
  // 最近一个月
  dateRange.push({
    label: "最近一个月",
    type: "4",
    addTime: startTime30.setTime(startTime30.getTime() - 3600 * 1000 * 24 * 30),
    endTime: endTime.getTime()
  });
  return dateRange;
};
